"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _default = (0, _createSvg.createSvg)('IconAccessibilityPerson', new _interfaces.SVGIconWithSizes((0, _defineProperty2.default)({}, _interfaces.IconSize.Small, {
  paths: ['M17,6 C17.5522847,6 18,6.44771525 18,7 C18,7.55228475 17.5522847,8 17,8 L13,8 L12.999928,10.9878788 C12.999976,10.9919135 13,10.995954 13,11 L13,18 C13,18.5522847 12.5522847,19 12,19 C11.4477153,19 11,18.5522847 11,18 L11,13 L9,13 L9,18 C9,18.5522847 8.55228475,19 8,19 C7.44771525,19 7,18.5522847 7,18 L7.0000996,12.0142597 C7.00003327,12.0095144 7,12.0047611 7,12 L7,7.999 L3,8 C2.44771525,8 2,7.55228475 2,7 C2,6.44771525 2.44771525,6 3,6 L17,6 Z M10,1 C11.1045695,1 12,1.8954305 12,3 C12,4.1045695 11.1045695,5 10,5 C8.8954305,5 8,4.1045695 8,3 C8,1.8954305 8.8954305,1 10,1 Z'],
  params: {
    width: '20',
    height: '20'
  },
  height: 20,
  width: 20
})));

exports.default = _default;